export default class NavBar extends HTMLElement {
    
}

customElements.define("nav-bar", NavBar);
